import React from 'react'

// Réplica do modelo "Comunicado e Avaliação de Tratamento Fitossanitário" da Biofix (A4, medidas em pt).
const LINE = '1pt solid #000'
const WIDTH = 572.6
const FONT = "'Times New Roman', Times, 'Liberation Serif', serif"

// Larguras das colunas da tabela principal (em pt); `span` indica quantas colunas a célula ocupa
const COLS = [41.9, 72.7, 48.5, 94, 70.4, 50, 40.2, 53.8, 28.8, 49.7]

const styles = {
  page: { width: '595.3pt', boxSizing: 'border-box', padding: '12pt 11pt 0', background: '#fff', fontFamily: FONT },
  sheet: { width: `${WIDTH}pt`, color: '#000', fontSize: '10.3pt', lineHeight: 1.1 },
  header: { display: 'flex', border: LINE, borderBottom: 0 },
  box: { borderLeft: LINE, borderRight: LINE, borderBottom: LINE, position: 'relative' },
  table: { borderCollapse: 'collapse', tableLayout: 'fixed', width: '550pt', margin: '-1pt 0 -1pt -1pt' },
  td: { border: LINE, padding: '0 1.5pt', verticalAlign: 'middle', overflow: 'hidden', wordBreak: 'break-word' },
  bold: { fontWeight: 'bold' },
  center: { textAlign: 'center' },
  small: { fontSize: '9.4pt' }
}

const Td = ({ span = 1, style, children, ...props }) => (
  <td colSpan={span} style={{ ...styles.td, ...style }} {...props}>
    {children}
  </td>
)

const Tr = ({ height, children }) => <tr style={{ height: `${height}pt` }}>{children}</tr>

// Valor alinhado à direita seguido da unidade (ex.: "360" "Hs")
const ValueUnit = ({ value, unit, width, align = 'right' }) => (
  <div style={{ display: 'flex' }}>
    <span style={{ width: `${width}pt`, textAlign: align, paddingRight: align === 'right' ? '1.5pt' : 0 }}>
      {value}
    </span>
    <span>{unit}</span>
  </div>
)

const abs = style => ({ position: 'absolute', ...style })

const Underlined = ({ left, width, bottom, children }) => (
  <div
    style={abs({
      left: `${left}pt`,
      width: `${width}pt`,
      bottom: `${bottom}pt`,
      borderBottom: LINE,
      textAlign: 'center'
    })}
  >
    {children || <>&nbsp;</>}
  </div>
)

const Header = ({ data }) => (
  <>
    <div style={{ ...styles.header, height: '62pt' }}>
      <div style={{ width: '417.7pt', display: 'flex', alignItems: 'center', paddingLeft: '18pt' }}>
        <img
          src="/pdfs/biofix/logo.png"
          alt="Biofix Agri"
          style={{ width: '195pt', height: 'auto', display: 'block' }}
        />
      </div>
      <div style={{ width: '154.9pt', borderLeft: LINE }}>
        {[
          ['O.S.', data.activityCode, 28.6],
          ['Nº Comunicado', data.communicationNumber, 33.4]
        ].map(([label, value, height], index) => (
          <div
            key={label}
            style={{
              height: `${height}pt`,
              display: 'flex',
              alignItems: 'center',
              borderTop: index ? LINE : 0,
              boxSizing: 'border-box'
            }}
          >
            <span style={{ width: '84.4pt', paddingLeft: '1.8pt' }}>{label}</span>
            <span>{value}</span>
          </div>
        ))}
      </div>
    </div>
    <div style={{ height: '14.3pt', border: LINE }} />
    <div
      style={{
        ...styles.center,
        ...styles.bold,
        fontSize: '11.3pt',
        height: '28pt',
        paddingTop: '16pt',
        boxSizing: 'border-box'
      }}
    >
      COMUNICADO E AVALIAÇÃO DE TRATAMENTO FITOSSANITÁRIO
    </div>
  </>
)

const MainTable = ({ data }) => (
  <table style={styles.table}>
    <colgroup>
      {COLS.map((width, index) => (
        <col key={index} style={{ width: `${width}pt` }} />
      ))}
    </colgroup>
    <tbody>
      <Tr height={16.3}>
        <Td span={2}>Nome da Empresa</Td>
        <Td span={8}>BIOFIX AGRI LTDA</Td>
      </Tr>
      <Tr height={16.3}>
        <Td>CNPJ</Td>
        <Td span={3}>31.707.506/0001-69</Td>
        <Td span={2}>Inscr. Estadual</Td>
        <Td span={4}>194.259.802.111</Td>
      </Tr>
      <Tr height={16.4}>
        <Td span={2}>Endereço</Td>
        <Td span={8}>Rua Piauí, 1299, sala 4-A - Centro - Avaré/SP</Td>
      </Tr>
      <Tr height={16.3}>
        <Td span={3}>
          <span style={{ display: 'inline-block', width: '42pt' }}>Telefone</span>(13) 3877-8322
        </Td>
        <Td span={2}>Fax</Td>
        <Td span={3}>
          <ValueUnit value="CREA-SP" unit="2180493" width={75} align="left" />
        </Td>
        <Td span={2} />
      </Tr>
      <Tr height={16.3}>
        <Td span={3}>Endereço eletrônico</Td>
        <Td
          span={7}
          style={{ fontFamily: 'Calibri, Carlito, sans-serif', color: '#0563c1', textDecoration: 'underline' }}
        >
          biofix@biofixagri.com
        </Td>
      </Tr>
      <Tr height={19.8}>
        <Td span={3}>Responsável Técnico</Td>
        <Td span={7} style={{ fontSize: '4.7pt', lineHeight: '6.6pt' }}>
          LEONARDO BRANDÃO DO NASCIMENTO / PEDRO FRANCISCO CARVALHO JUNIOR / JOSÉ RENATO LEITE BARBOSA / LAIRA CAROL
          PAFFETTI DE OLIVEIRA / GUILHERME BIZERA KOHLER / LORENNA WISNIEWSKI PELETTI / MARIA KAROLINE DE CARVALHO
          RODRIGUES DE SOUSA / LIGIA MUNHOZ / ANNA FLÁVIA MORAES NOGUEIRA / CARLOS EDUARDO PIRES / WELBER MELO DA SILVA
          / DAVI PESSOA DA SILVA
        </Td>
      </Tr>
      <Tr height={25.2}>
        <Td span={3}>Registro no Conselho</Td>
        <Td span={4} style={{ fontSize: '6.6pt', lineHeight: '8.6pt' }}>
          151897653 / 1711096440 / 2618294130 / 2618552598 / 2520233079 / 1722538520 / 1122713975 / 2620995094 / 1736671
          / 5071508443 / 5071767812 / 5071766597
        </Td>
        <Td style={{ ...styles.center, ...styles.small }}>Cadastro Nº</Td>
        <Td span={2}>BR SP 0896</Td>
      </Tr>
      <Tr height={13}>
        <Td span={2} style={styles.center} rowSpan={2}>
          Interessado
        </Td>
        <Td span={8} style={styles.small}>
          {data.interested}
        </Td>
      </Tr>
      <Tr height={26.6}>
        <Td span={8} style={{ fontSize: '8.4pt', lineHeight: '10.8pt' }}>
          {data.interestedDetails}
        </Td>
      </Tr>
      <Tr height={16.3}>
        <Td span={2} style={styles.small}>
          Mercadoria Tratada
        </Td>
        <Td span={3}>{data.goods}</Td>
        <Td span={5}>{data.ship}</Td>
      </Tr>
      <Tr height={15}>
        <Td span={3}>Tipo de acondicionamento</Td>
        <Td style={styles.center}>Granel</Td>
        <Td span={2} style={styles.center}>
          Quantidade (kg)
        </Td>
        <Td span={4}>
          <ValueUnit value={data.quantity} unit="mt" width={94} align="center" />
        </Td>
      </Tr>
      <Tr height={45}>
        <Td span={2} style={styles.center}>
          Local/End. do tratamento
        </Td>
        <Td style={{ ...styles.center, padding: 0, wordBreak: 'normal' }}>{data.treatmentPlace}</Td>
        <Td span={3} style={{ ...styles.small, lineHeight: '12pt' }}>
          {data.treatmentAddress}
        </Td>
        <Td style={{ verticalAlign: 'top' }}>Data</Td>
        <Td style={{ ...styles.center, verticalAlign: 'top' }}>{data.date}</Td>
        <Td style={{ verticalAlign: 'top' }}>Hora</Td>
        <Td style={{ ...styles.center, verticalAlign: 'top' }}>{data.time}</Td>
      </Tr>
      <Tr height={15}>
        <Td span={2}>Tipo de tratamento</Td>
        <Td span={2}>Fumigação (FPE- FOSFINA)</Td>
        <Td span={3}>Tempo de exposição</Td>
        <Td span={3}>
          <ValueUnit value={data.exposureTime} unit={data.exposureTime ? 'Hs' : ''} width={82.6} />
        </Td>
      </Tr>
      <Tr height={15}>
        <Td span={3} style={styles.center}>
          Produto utilizado(p.a.)
        </Td>
        <Td style={{ ...styles.center, ...styles.small }}>Fosfeto de alumínio</Td>
        <Td style={{ ...styles.center, ...styles.bold, fontSize: '8.4pt' }}>{data.product}</Td>
        <Td>Dosagem</Td>
        <Td span={4}>
          <ValueUnit value={data.dosage} unit="g fosfina /m3" width={40.2} />
        </Td>
      </Tr>
    </tbody>
  </table>
)

const SignatureBlock = ({ data }) => (
  <>
    <div style={{ ...styles.box, height: '73.6pt', borderTop: LINE }}>
      <div style={abs({ left: '1.3pt', bottom: '14.5pt' })}>Santos,</div>
      <div style={abs({ left: '1.3pt', bottom: '0.5pt' })}>(Local)</div>
      <Underlined left={41.9} width={215.3} bottom={14.3}>
        {data.generatedAt}
      </Underlined>
      <div style={abs({ left: '41.9pt', width: '215.3pt', bottom: '0.5pt', ...styles.center })}>(Data)</div>
      <Underlined left={327.6} width={222} bottom={14.3} />
      <div style={abs({ left: '327.6pt', width: '222pt', bottom: '0.5pt', ...styles.center })}>
        Assinatura do informante
      </div>
    </div>
    <div style={{ ...styles.box, height: '50.4pt' }}>
      <div
        style={abs({
          left: 0,
          width: '114.6pt',
          top: '1pt',
          textAlign: 'center',
          fontSize: '8.4pt',
          lineHeight: '10.8pt'
        })}
      >
        Recebimento comunicado
        <br />
        MAPA:
      </div>
      <div style={abs({ left: '1.3pt', bottom: '15pt' })}>Recebido em</div>
      <div style={abs({ left: '114.6pt', width: '142.6pt', top: '6pt', ...styles.center, ...styles.small })}>
        {data.mapaPort}
      </div>
      <Underlined left={114.6} width={142.6} bottom={14.3} />
      <div style={abs({ left: '329.3pt', top: '5pt' })}>Recebido:</div>
      <Underlined left={377.5} width={172.1} bottom={29.3} />
      <div style={abs({ left: '327.6pt', width: '222pt', bottom: '15pt', ...styles.center })}>carimbo e assinatura</div>
    </div>
    <div style={{ ...styles.box, height: '42.3pt' }}>
      <div style={abs({ left: 0, width: '550pt', top: '16.8pt', ...styles.center, ...styles.bold })}>
        USO EXCLUSIVO DO MAPA
      </div>
      <div style={abs({ left: '1.3pt', top: '30.8pt', ...styles.bold })}>AVALIAÇÃO DO TRATAMENTO</div>
    </div>
  </>
)

// Linhas da avaliação: [item, pergunta complementar, altura]
const EVALUATION = [
  ['Equipamentos de Segurança', 'Quais?', 14.2],
  ['Equipamentos de aplicação', 'Quais?', 14.3],
  ['Alerta de perigo', 'Tipo?', 15],
  ['Sistema de vedação', 'Tipo?', 15.1],
  ['Verificaram-se incidentes', 'Tipo?', 15],
  ['Considerou adequado', 'Por quê?', 24.4],
  ['Leituras parciais de concentração', '', 15]
]
const EVALUATION_COLS = [163.1, 47.8, 46.2, 70.4, 50, 40.2, 154.9]

const EvaluationTable = () => (
  <table style={{ ...styles.table, width: `${WIDTH}pt`, margin: '-1pt 0 0' }}>
    <colgroup>
      {EVALUATION_COLS.map((width, index) => (
        <col key={index} style={{ width: `${width}pt` }} />
      ))}
    </colgroup>
    <tbody>
      {EVALUATION.map(([item, question, height], index) => {
        const isLast = index === EVALUATION.length - 1
        return (
          <Tr key={item} height={height}>
            <Td style={isLast ? { fontSize: '9.4pt' } : undefined}>{item}</Td>
            <Td />
            <Td style={styles.bold}>SIM</Td>
            <Td />
            <Td style={styles.bold}>NÃO</Td>
            <Td
              style={{
                ...styles.bold,
                whiteSpace: 'nowrap',
                overflow: 'visible',
                fontSize: question === 'Por quê?' ? '9.4pt' : undefined
              }}
            >
              {question}
            </Td>
            {isLast ? <Td style={{ border: 0 }} /> : <Td />}
          </Tr>
        )
      })}
    </tbody>
  </table>
)

const Observations = ({ data }) => (
  <>
    <div style={{ ...styles.box, ...styles.center, ...styles.bold, height: '15pt', lineHeight: '14pt', borderTop: 0 }}>
      OBSERVAÇÕES
    </div>
    <div style={{ ...styles.box, minHeight: '57.3pt', fontSize: '9.4pt', lineHeight: '14pt', padding: '0 1.3pt' }}>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '211.3pt' }}>
          <div style={{ display: 'flex' }}>
            <span style={{ width: '42pt' }}>Navio:</span>
            <span>{data.ship}</span>
          </div>
          <div style={{ display: 'flex' }}>
            <span style={{ width: '42pt' }}>Destino:</span>
            <span>{data.destination}</span>
          </div>
        </div>
        <div style={{ flex: 1, lineHeight: '12pt', paddingTop: '1pt', wordBreak: 'break-word' }}>LPCO: {data.lpco}</div>
      </div>
      <div style={{ wordBreak: 'break-word' }}>Exportadores: {data.exporters}</div>
      <div>Data e hora de tratamento são aproximadas, seguindo previsão da Agência.</div>
    </div>
    <div style={{ ...styles.box, ...styles.center, ...styles.bold, height: '14.3pt', lineHeight: '13pt' }}>
      RESPONSÁVEL PELA AVALIAÇÃO
    </div>
    <div style={{ ...styles.box, height: '72.1pt', fontSize: '11.3pt', lineHeight: '14.5pt', padding: '2pt 1.3pt 0' }}>
      <div>Nome:</div>
      <div style={{ fontSize: '10.3pt' }}>Cargo:</div>
      <div>Identificação:</div>
      <div style={abs({ left: '329.5pt', bottom: '14pt' })}>Fiscal Federal Agropecuário</div>
    </div>
  </>
)

const PdfDocument = ({ data }) => (
  <div id="pdfPage" style={styles.page}>
    <style>{`@page { size: A4; margin: 0 }`}</style>
    <div style={styles.sheet}>
      <Header data={data} />
      <div style={{ ...styles.box, borderTop: LINE, borderBottom: 0 }}>
        <MainTable data={data} />
      </div>
      <SignatureBlock data={data} />
      <EvaluationTable />
      <Observations data={data} />
    </div>
  </div>
)

export default PdfDocument
